// extracted by mini-css-extract-plugin
export default {"cta":"SE-z","disabled":"TE-z"};